import React from 'react';
import { Link } from 'react-router-dom';
import './About.css'; // Arquivo CSS customizado para efeitos adicionais

function About() {
  return (
    <div className="about-hero" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#343a40' }}>
      <div className="container text-center">
        <h1 className="hero-title" style={{ color: '#fff', fontWeight: 'bold', fontSize: '3.5rem', marginBottom: '20px' }}>
          Bem-vindo ao <span style={{ color: '#007bff' }}>Não Dito</span>
        </h1>
        <p className="hero-subtitle" style={{ color: '#d4d4d4', fontSize: '1.5rem', marginBottom: '40px' }}>
          Aqui, damos voz ao que ficou em silêncio.
        </p>
        <p className="hero-description" style={{ color: '#f8f9fa', fontSize: '1.25rem', lineHeight: '1.8', marginBottom: '40px' }}>
          Todos temos palavras que jamais foram ditas, sentimentos guardados que nunca chegaram ao destino. O
          <strong> Não Dito </strong> é um espaço para compartilhar essas mensagens invisíveis, aquelas que, por algum motivo, não
          foram enviadas, mas ainda ecoam dentro de nós.
        </p>
        <Link to="/adicionar" className="btn btn-primary btn-lg" style={{ padding: '10px 30px', fontSize: '1.2rem', marginBottom: '20px' }}>
          Compartilhe Sua Mensagem
        </Link>
        <div>
          <Link to="/mensagens" className="btn btn-link text-light" style={{ fontSize: '1.1rem' }}>
            Entrar no site
          </Link>
        </div>
      </div>
    </div>
  );
}

export default About;